/* =====================================================================
   EverMount Replacement Filters PDP - pack + subscription buy box
   Ported from replacement filters/wt-filters-proto.js, with every hardcoded
   number replaced by window.WT_FILTERS (emitted from Liquid by
   sections/wt-filters-buy-box.liquid: variant prices, compare-at prices and
   each variant's own Seal selling-plan allocations).

   Loaded only by sections/wt-filters-boot.liquid / snippets/wt-filters-head.liquid,
   both gated on templates/product.emf-filters-template-2-0.json. It cannot run on
   another product.

   What it owns:
     packs        the 5/10/20-Pack pills -> the product form's variant id, gallery
     purchase     Subscribe (with its frequency) / One-time -> the form's selling_plan
     prices       main price, struck price, SAVE badges, Total today, the
                  "then $X every N months" line, the Shop Pay line
     add to cart  ONE /cart/add.js line: the selected variant, plus the selected
                  selling_plan when subscribing; then the Rebuy Smart Cart opens

   What it deliberately leaves to assets/wt-fountain.js (loaded before it, reused
   unmodified): the delivery date, both help dialogs, the accordion, the mobile
   type fitting, the FAQ chips and the video fix. wt-fountain.js's kit selector
   stays off here because this page publishes no window.WT_PRICING.

   DEPENDS ON:
     window.WT_FILTERS  sections/wt-filters-buy-box.liquid
     window.WTCart      assets/wt-evermount-gifts.js (site-wide). Optional: without
                        it the add goes straight to /cart/add.js and Rebuy.
   ===================================================================== */
if (window.__wtFiltersJs) { /* already running (theme editor re-inserted the tag) */ } else {
window.__wtFiltersJs = 1;
(function () {
  'use strict';

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };

  /* Re-read in init(): a theme-editor re-render of the buy box replaces
     window.WT_FILTERS with a new object (new settings, new prices). */
  var CFG, PACKS, TEXT, KEYS;
  function loadConfig() {
    CFG = window.WT_FILTERS;
    if (!CFG || !CFG.packs) return false;
    PACKS = CFG.packs; TEXT = CFG.text || {}; KEYS = Object.keys(PACKS);
    return KEYS.length > 0;
  }
  if (!loadConfig()) return;

  /* Money in the shopper's currency, formatted like the theme ($15.00). */
  var fmt = null;
  try { fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: CFG.currency || 'USD', currencyDisplay: 'narrowSymbol' }); } catch (e) {}
  function money(c) { return fmt ? fmt.format(c / 100) : '$' + (c / 100).toFixed(2); }
  function tpl(t, map) { return String(t || '').replace(/\{(\w+)\}/g, function (m, k) { return map[k] != null ? String(map[k]) : m; }); }

  var state = {
    pack: PACKS[CFG.initial] ? CFG.initial : KEYS[0],
    sub: true,
    plan: null,           /* selling-plan id; null = the pack's first (default) plan */
    subWanted: true       /* the shopper's last choice, kept across pack changes */
  };
  function pack() { return PACKS[state.pack]; }
  function planOf(p, id) {
    var ps = (p && p.plans) || [];
    for (var i = 0; i < ps.length; i++) if (String(ps[i].id) === String(id)) return ps[i];
    return ps[0] || null;
  }
  function plan() { return planOf(pack(), state.plan); }
  function subscribed() { return state.sub && !!plan(); }

  /* The numbers for the current state. Owner rules (2026-09-21):
       now   = Subscribe: the plan's first-order price (25% off today)
               One-time:  the variant price
       was   = the variant's compare-at price (never below its price), struck only
               when it is above `now` - so a 5-Pack one-time strikes nothing
       renew = the plan's recurring price (15% off), for the "then ..." line */
  function numbers() {
    var p = pack(), pl = plan(), sub = subscribed();
    var now = sub ? pl.first : p.price;
    var was = Math.max(p.cmp || 0, p.price);
    var show = was > now;
    return { now: now, was: was, show: show, pct: show ? Math.round((was - now) / was * 100) : 0, renew: sub ? pl.renew : null, plan: pl, sub: sub };
  }

  /* ---- element handles, re-resolved after every buy-box (re)render ---- */
  var W, form, idInput, planInput, btn;
  function resolve() {
    W = $('.wtsel--packs');
    /* Still inside the hidden holder = the buy box could not move it (giveUp):
       touch nothing, so the theme's own form and price stay in charge. */
    if (!W || W.closest('.wt-buybox-src')) { W = null; form = null; return; }
    var sect = (W && W.closest('.shopify-section')) || document;
    form = $('product-form form[action*="/cart/add"]', sect) || $('product-form form[action*="/cart/add"]');
    idInput = form && form.querySelector('input[name="id"]');
    btn = form && form.querySelector('button[type="submit"], [name="add"]');
    /* The theme's form has no selling_plan input of its own (the theme's Seal
       widget blocks are disabled in the template, and Seal's auto-injected widget
       is switched off by window.disableSealSubscriptionsApp in the head snippet /
       boot section). The buy box's inline script normally created this input
       already (so a tap before this file runs is charged correctly); otherwise it
       is created here. Disabled, and so left out of the post, on One-time. */
    planInput = form && form.querySelector('input[name="selling_plan"]');
    if (form && !planInput) {
      planInput = document.createElement('input');
      planInput.type = 'hidden'; planInput.name = 'selling_plan'; planInput.setAttribute('data-wt-filters', '');
      form.appendChild(planInput);
    }
  }

  /* ---- prices repaint instantly, like the fountain page (owner 2026-09-22: no tween, no pulse) ---- */
  function setMoney(el, cents) {
    if (!el) return;
    el.setAttribute('data-cents', cents);
    el.textContent = money(cents);
  }
  function bump() {}
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }

  /* ---- frequency list follows the pack (each pack has its own Seal plans) ---- */
  function buildFreq() {
    var sel = $('#filterFreq'); if (!sel) return;
    var p = pack();
    if (sel.getAttribute('data-pack') !== state.pack) {
      var want = (p.plans || []).map(function (pl) { return String(pl.id); }).join(',');
      var have = [].map.call(sel.options, function (o) { return o.value; }).join(',');
      if (want !== have) {
        sel.innerHTML = '';
        (p.plans || []).forEach(function (pl) {
          var o = document.createElement('option');
          o.value = String(pl.id);
          o.textContent = tpl(TEXT.freqOption || '{label}', { label: pl.label });
          sel.appendChild(o);
        });
      }
      sel.setAttribute('data-pack', state.pack);
    }
    if (plan()) sel.value = String(plan().id);
  }

  /* ---- the product form: what the cart will actually receive ---- */
  function syncForm() {
    var p = pack(), n = numbers();
    if (idInput) { idInput.value = String(p.id); idInput.removeAttribute('disabled'); }
    if (planInput) {
      if (n.sub) { planInput.value = String(n.plan.id); planInput.disabled = false; }
      else { planInput.value = ''; planInput.disabled = true; }
    }
    if (btn) {
      /* The label is written from the theme's own translation (WT_FILTERS.text.addToCart),
         not snapshotted from the button: when the page opens on a sold-out pack the theme
         renders the button as "Sold out", and a snapshot would carry that onto every
         available pack. (The theme's button holds plain text only.) */
      if (p.available) { setText(btn, TEXT.addToCart || 'Add to cart'); btn.disabled = false; }
      else { setText(btn, TEXT.soldOut || 'Sold out'); btn.disabled = true; }
    }
  }

  function paint(animate) {
    if (!W) return;
    var p = pack(), n = numbers(), pl = n.plan;
    var saveTxt = tpl(TEXT.save || 'SAVE {pct}%', { pct: n.pct });

    /* pills */
    $$('.pill', W).forEach(function (b, i) {
      var on = b.getAttribute('data-kit') === state.pack;
      b.classList.toggle('sel', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on) W.setAttribute('data-sel', String(i));
    });

    /* main price (the theme's price block, wrapped by the buy box) */
    var sale = $('#mainSale'), cmp = $('#mainCompare'), save = $('#priceSave');
    setMoney(sale, n.now, animate);
    if (cmp) {
      var cel = cmp.closest('compare-at-price') || cmp.parentElement;
      if (cel) cel.hidden = !n.show;
      setMoney(cmp, n.was, animate);
    }
    var saleEl = sale && sale.closest('sale-price');
    if (saleEl) { saleEl.classList.toggle('text-on-sale', n.show); saleEl.classList.toggle('text-subdued', !n.show); }
    if (save) { if (save.textContent !== saveTxt && animate) bump(save); setText(save, saveTxt); save.hidden = !n.show; }

    /* purchase options */
    var hasPlans = !!(p.plans && p.plans.length);
    var subMode = $('.fadd-mode[data-mode="sub"]', W);
    if (subMode) subMode.hidden = !hasPlans;
    buildFreq();
    $$('.fadd-mode', W).forEach(function (m) {
      var on = (m.getAttribute('data-mode') === 'sub') === n.sub;
      m.classList.toggle('is-active', on);
      var r = $('.fadd-mbox', m); if (r) { r.setAttribute('aria-checked', on ? 'true' : 'false'); r.tabIndex = on ? 0 : -1; }
    });

    /* the badge, the card heading and the dialog subtitle describe the plan the
       shopper has picked (or would get), so they keep their numbers on One-time */
    var fSave = $('#filterSave'); if (fSave) fSave.hidden = !pl;
    var pctMap = { pct: pl ? pl.firstPct : 0, renew: pl ? pl.pct : 0 };
    $$('.fadd-save-t[data-wt-tpl], .fadd-subhead-t[data-wt-tpl], .ft-sub[data-wt-tpl]').forEach(function (el) {
      setText(el, tpl(el.getAttribute('data-wt-tpl'), pctMap));
    });

    /* Total today */
    var tw = $('#totWas'), tn = $('#totNow'), ts = $('#totSave'), sl = $('#subLine'), pay = $('#payLine');
    setMoney(tn, n.now, animate);
    if (tw) { tw.hidden = !n.show; setMoney(tw, n.was, animate); }
    if (ts) { if (ts.textContent !== saveTxt && animate) bump(ts); setText(ts, saveTxt); ts.hidden = !n.show; }
    if (sl) {
      if (n.sub) { setText(sl, tpl(TEXT.subLine || 'then {price} every {every} · cancel anytime', { price: money(n.renew), every: pl.every })); sl.hidden = false; }
      else sl.hidden = true;
    }
    /* Shop Pay Installments excludes subscriptions (fountain rule): BOTH installment
       lines - the one under Total today and the one under the main price - hide while
       Subscribe is selected (owner 2026-09-22) and show on One-time. */
    if (pay) pay.hidden = n.sub;
    var bnpl = $('#bnplBar'); if (bnpl) bnpl.hidden = n.sub;

    paintSticky(p);
    syncForm();
    document.dispatchEvent(new CustomEvent('wt:filters-change', { detail: { pack: state.pack, variant: p.id, selling_plan: n.sub ? n.plan.id : null, now: n.now } }));
  }

  /* Sticky bar (sections/wt-filters-sticky-atc.liquid): the pack chip and the pack's
     picture are this page's; price, SAVE, delivery date and rating are mirrored by
     wt-fountain.js, which reads #totNow/#totWas/#totSave/.shipeta/.loox-rating. */
  function paintSticky(p) {
    var bar = document.getElementById('wt-sticky-atc');
    if (!bar) return;
    var pill = $('.pill[data-kit="' + state.pack + '"] b', W);
    var name = pill ? pill.textContent.trim() : (p.title || '');
    $$('[data-wtsb="variant"]', bar).forEach(function (el) { setText(el, name); });
    var media = p.media && document.querySelector('product-gallery [data-media-id="' + p.media.id + '"] img');
    var src = media && (media.currentSrc || media.getAttribute('src'));
    if (src) $$('[data-wtsb="img"]', bar).forEach(function (img) { if (img.getAttribute('src') !== src) img.setAttribute('src', src); });
  }

  /* Pack -> gallery, the way the fountain's kit pills do it: the theme's
     product-gallery scrolls to a variant's featured media on "variant:change". */
  function syncGallery(prevKey) {
    var p = pack(), prev = PACKS[prevKey];
    if (!form || !p.media) return;
    try {
      form.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: {
        formId: form.id,
        variant: { id: Number(p.id), featured_media: p.media },
        previousVariant: { id: prev ? Number(prev.id) : null, featured_media: prev ? prev.media : null }
      }}));
    } catch (e) {}
  }

  /* ---- events: delegated, so a theme-editor re-render needs no re-binding ---- */
  document.addEventListener('click', function (e) {
    if (!W || !e.target.closest) return;
    var pill = e.target.closest('.wtsel--packs .pill');
    if (pill) {
      var k = pill.getAttribute('data-kit');
      if (!PACKS[k] || k === state.pack) return;
      var prev = state.pack;
      state.pack = k;
      state.plan = null;                          /* the new pack's own default plan */
      if (!(PACKS[k].plans || []).length) state.sub = false;
      else if (state.subWanted !== false) state.sub = true;
      paint(true); syncGallery(prev);
      return;
    }
    var mode = e.target.closest('.wtsel--packs .fadd-mode');
    if (mode) {
      /* a click on the frequency select counts as choosing Subscribe too (the
         select still opens: nothing is prevented) */
      var want = mode.getAttribute('data-mode') === 'sub';
      if (want && !(pack().plans || []).length) return;
      state.subWanted = want;
      if (want !== state.sub) { state.sub = want; paint(true); }
    }
  });
  document.addEventListener('change', function (e) {
    if (!e.target || e.target.id !== 'filterFreq') return;
    state.plan = Number(e.target.value); state.sub = true; state.subWanted = true;
    paint(true);
  });
  document.addEventListener('keydown', function (e) {
    var grp = e.target && e.target.closest && e.target.closest('.wtsel--packs .fadd-modes');
    if (!grp || e.target.tagName === 'SELECT') return;
    var arrow = /^Arrow(Up|Down|Left|Right)$/.test(e.key), act = e.key === ' ' || e.key === 'Enter';
    if (!arrow && !act) return;
    e.preventDefault();
    var hasPlans = !!(pack().plans || []).length;
    if (arrow) state.sub = hasPlans ? !state.sub : false;
    else { var m = e.target.closest('.fadd-mode'); if (!m) return; state.sub = m.getAttribute('data-mode') === 'sub' && hasPlans; }
    state.subWanted = state.sub;
    paint(true);
    var rb = $('.fadd-mode.is-active .fadd-mbox', W); if (rb) rb.focus();
  });

  /* ---- add to cart ----
     Window, capture phase: this runs before ANY other submit listener on the page
     (the theme's ProductForm, Rebuy, and wt-evermount-gifts.js, which listens on
     document) and stops the event, so exactly one request is made and nothing else
     can add a second copy or strip the selling plan. */
  function smartCart() { return (window.Rebuy && window.Rebuy.SmartCart) ? window.Rebuy.SmartCart : null; }
  function openDrawer() {
    /* Preferred: the site-wide helper the fountain page uses (same Rebuy calls). */
    if (window.WTCart && typeof window.WTCart.openCart === 'function') {
      window.WTCart.refreshCart(); window.WTCart.openCart(); return;
    }
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    var waited = 0;
    (function poll() {
      var sc = smartCart(), rc = window.Rebuy && window.Rebuy.Cart;
      if (sc && typeof sc.show === 'function') {
        try { if (rc && typeof rc.fetchCart === 'function') rc.fetchCart(function (c) { if (c) try { sc.setCart(c); } catch (e) {} }); } catch (e) {}
        sc.show(); return;
      }
      waited += 150;
      if (waited >= 8000) { window.location.href = '/cart'; return; }
      setTimeout(poll, 150);
    })();
  }
  function post(items) {
    if (window.WTCart && typeof window.WTCart.addLines === 'function') return window.WTCart.addLines(items);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.text().then(function (t) { var d = null; try { d = t ? JSON.parse(t) : null; } catch (e) {} if (!r.ok) return Promise.reject({ status: r.status, data: d }); return d; });
    });
  }
  function showError(err) {
    if (!form) return;
    var box = form.querySelector('.wt-filters-err');
    if (!box) { box = document.createElement('p'); box.className = 'wt-filters-err'; box.setAttribute('role', 'alert'); form.appendChild(box); }
    var d = err && err.data;
    box.textContent = (d && (d.description || d.message)) || TEXT.addError || 'Sorry, we couldn’t add that to your cart.';
    box.hidden = false;
  }

  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !form || !W || f !== form) return;   /* not armed (no card on the page): the theme handles it */
    var p = pack(), n = numbers();
    /* only ever our own product */
    var pid = f.querySelector('input[name="product-id"]');
    if (pid && String(pid.value) !== String(CFG.productId)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!p.available || f.getAttribute('aria-busy') === 'true') return;

    var qtyEl = f.querySelector('[name="quantity"]');
    var item = { id: Number(p.id), quantity: Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1) };
    if (n.sub) {
      item.selling_plan = Number(n.plan.id);
      /* HIDDEN line note for the Rebuy drawer ("Ships every 2 months"); rendered by
         wt-evermount-gifts.js, never printed at checkout. Subscriptions only. */
      if (TEXT.cartNote) item.properties = { _wt_note: tpl(TEXT.cartNote, { every: n.plan.every }) };
    }

    /* What the cart holds of this exact line right before the add, so a timed-out add is
       judged by "did the quantity go up", not "is it there" (audit M10, 2026-10-15). */
    var before = null;
    var err = f.querySelector('.wt-filters-err'); if (err) err.hidden = true;
    f.setAttribute('aria-busy', 'true');
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    function release() { f.removeAttribute('aria-busy'); if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = !pack().available; } }

    var snap = (window.WTCart && typeof window.WTCart.qtyBefore === 'function')
      ? window.WTCart.qtyBefore(item.id, item.selling_plan || null) : Promise.resolve(null);
    snap.then(function (n) { before = n; return post([item]); }).then(function () {
      release();
      try { openDrawer(); } catch (e2) { window.location.href = '/cart'; }
    }, function (e3) {
      /* Never blind-retry a non-idempotent add. A server answer (422: sold out, plan
         not allowed...) is shown. A client-side failure (timeout, dropped
         connection) says nothing about whether Shopify committed the add, so the
         cart is read back first: if the line is there, carry on to the drawer as a
         success instead of inviting a retry that would make it quantity 2. */
      if (e3 && e3.status) { release(); showError(e3); return; }
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        var have = (cart.items || []).reduce(function (n, li) {
          var sp = li.selling_plan_allocation && li.selling_plan_allocation.selling_plan ? li.selling_plan_allocation.selling_plan.id : null;
          return n + (String(li.variant_id) === String(item.id) && String(sp || '') === String(item.selling_plan || '') ? li.quantity : 0);
        }, 0);
        /* no baseline (helper missing): fall back to "the line is there" */
        var landed = before == null ? have > 0 : have > before;
        release();
        if (landed) { try { openDrawer(); } catch (e4) { window.location.href = '/cart'; } }
        else showError(e3);
      }, function () { release(); showError(e3); });
    });
  }, true);

  /* ---- init / re-init ---- */
  function init() {
    if (!loadConfig()) return;
    if (!PACKS[state.pack]) { state.pack = PACKS[CFG.initial] ? CFG.initial : KEYS[0]; state.plan = null; }
    else if (state.plan != null && !(PACKS[state.pack].plans || []).some(function (pl) { return String(pl.id) === String(state.plan); })) state.plan = null;
    resolve();
    if (!W) return;
    if (!(pack().plans || []).length) state.sub = false;
    paint(false);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('wt:buy-box-ready', init);
  document.addEventListener('wt:price-rewrapped', function () { paint(false); });
  /* bfcache restore: the form may hold stale values; repaint from state */
  window.addEventListener('pageshow', function (e) { if (e.persisted) init(); });

  window.WTFilters = { state: state, paint: paint, numbers: numbers };
})();
} /* end __wtFiltersJs guard */
